import { Component, OnInit, inject } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-language-picker',
  templateUrl: './language-picker.component.html',
  styleUrls: ['./language-picker.component.scss'],
  standalone: false,
})
export class LanguagePickerComponent implements OnInit {
  translate = inject(TranslateService);

  ngOnInit() {}

  public changeLanguage(key) {
    localStorage.setItem('serviceman_lang', key);
    this.translate.use(key);
  }
}
